export default __webpack_public_path__ + "static/logo-f288b772ce4b20a5942e6a70d00afdfc.svg";